import React from 'react';
import StripeCheckout from 'react-stripe-checkout';
import { connect } from 'react-redux';
import { submitStripePayment, getCharge } from '../actions/stripe';

import './Payments.css';
class StripePayment extends React.Component {
  constructor(props) {
    super(props);

    let stripeApiKey;
    if (
      window.location.href.includes('host') ||
      window.location.href.includes('uat') ||
      window.location.href.includes('dev')
    ) {
      stripeApiKey = 'pk_test_tPBRumVKDIgbMtH8tJqJ9nq400QX3ymf5T';
    } else {
      stripeApiKey = 'pk_live_u52QNi4iX4mjIOIcSvszHRFT00NWy0DdEb';
    }

    this.state = {
      amount: 0,
      stripeApiKey: stripeApiKey
    };
  }

  handleClose = () => {
    console.log('App#handleClose');
  };

  handleOpen = () => {
    console.log('App#handleOpen');
  };

  handleToken = (token) => {
    let body = {
      token: token,
      amount: this.state.amount,
      description: 'A Stripe Charge',
      charge_id: this.props.match.params.charge_id
    };

    this.props.submitStripePayment(body);
  };

  componentDidMount() {
    let chargeId = this.props.match.params.charge_id;
    this.props.getCharge(chargeId).then(
      function () {
        let chargeDetails = this.props.stripe.charge;
        if (chargeDetails?.paymentDetails?.chargeAmount) {
          this.setState({
            amount: chargeDetails.paymentDetails.chargeAmount
          });
          document.getElementsByClassName('StripeCheckout')[0].click();
        }
      }.bind(this)
    );
  }

  render() {
    return (
      <div>
        <div className='row off-white-bg no-margin'>
          <div className='col-sm-12'>
            <div className='row no-margin'>
              {this.props.stripe.chargeLoader && (
                <div
                  className='col-sm-12 section-title payments-h3 text-center'
                  style={{ padding: '120px' }}
                >
                  Fetching charge details...
                  <span>
                    <i className='fa fa-spinner fa-pulse fa-fw'></i>
                    <span className='sr-only'>Loading...</span>
                  </span>
                </div>
              )}
              {this.props.stripe.stripePaymentLoader && (
                <div
                  className='col-sm-12 section-title payments-h3 text-center'
                  style={{ padding: '120px' }}
                >
                  Processing Payment...
                  <span>
                    <i className='fa fa-spinner fa-pulse fa-fw'></i>
                    <span className='sr-only'>Loading...</span>
                  </span>
                </div>
              )}
              {this.props.stripe.chargeFailure && (
                <div
                  className='col-sm-12 section-title payments-h3 red-text text-center'
                  style={{ padding: '120px' }}
                >
                  Sorry! Failed to fetch charge details.
                </div>
              )}
              {this.props.stripe.stripeFailure && (
                <div
                  className='col-sm-12 section-title payments-h3 red-text text-center'
                  style={{ padding: '120px' }}
                >
                  Sorry! Payment failed.
                </div>
              )}
              {this.props.stripe.stripeSuccess && (
                <div
                  className='col-sm-12 section-title payments-h3 success-text text-center'
                  style={{ padding: '120px' }}
                >
                  Successful Payment
                </div>
              )}
              {!this.props.stripe.chargeLoader &&
                !this.props.stripe.stripePaymentLoader &&
                !this.props.stripe.stripeSuccess &&
                !this.props.stripe.stripeFailure &&
                !this.props.stripe.chargeFailure && (
                  <div
                    className='col-sm-12 section-title payments-h3 text-center'
                    style={{ padding: '120px' }}
                  >
                    <div>Cotality Payment</div>
                    <StripeCheckout
                      allowRememberMe={false}
                      amount={Math.round(this.state.amount * 100)}
                      closed={this.handleClose}
                      description='Payment with Card'
                      image='https://corestore.corelogic.com.au/favicon.png'
                      locale='en'
                      currency='AUD'
                      name='Cotality'
                      stripeKey={this.state.stripeApiKey}
                      token={this.handleToken}
                    />
                  </div>
                )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    stripe: state.stripe
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    submitStripePayment: (body) => dispatch(submitStripePayment(body)),
    getCharge: (chargeId) => dispatch(getCharge(chargeId))
  };
};

let StripePaymentPage = connect(mapStateToProps, mapDispatchToProps)(StripePayment);

export default StripePaymentPage;
